import theme from '../theme';

const letterColor = (status: string) => {
  const letterColors: {[key: string]: string} = theme.status.letter;
  return letterColors[status];
};

export default letterColor;
